<template>
  <div class="s-layout" :style="colorObject">
    <div class="s-container">

      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { themeColorFn } from "@/mixins/liff/themeColor";

export default {
  mixins: [themeColorFn({ themeConfigPage: 'game' })],  
  computed: {
    ...mapGetters("liffGeneral", ["themeConfig", "meta"]),
  },
  data() {
    return {
      //themeConfigPage: "rewards",
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/liff/main.css";
@import "../../../assets/css/liff/liff_init_theme_config.css";

.s-layout,
.s-layout *,
.s-layout *:before,
.s-layout *:after {
  --s-gray-light: #c0c4cc;
}

.s-layout {
  color: var(--s-gray-dark);
  background-color: var(--liff-layout_bg_color);
}

.content {
  padding-bottom: 24px;
  background: var(--liff-content_bg_color);
}
</style>
